module.exports = __webpack_public_path__ + "static/media/21ECLAC39.f6f10526.jpg";